import { BillingSchedule } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1360. 請求予定登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/billing_schedules
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};
const createBillingSchedule = (props: Props): Promise<BillingSchedule> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/billing_schedules`, props);
};

export const useCreateBillingSchedule = () => {
  return useMutation({
    mutationFn: createBillingSchedule,
  });
};
